<template>
  <modal name="yagiprimefontpayment-dialog" :adaptive="true" :scrollable="true" height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeFontpaymentDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem;"
        type="text"></el-button>
    </div>


    <!--ポップアップ-->
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align: center; border-top: none; padding-top: 0;">
        <p style="font-size: 1rem; font-weight: bold;">＼ヤギプライム登録で全てのフォントが使えます！／</p>
        <div
          style="display: flex; min-width: 100%; justify-content: center; align-items: center; padding: 5px 15px 15px;">
          <p style="font-size: 1rem; font-weight: bold;">月額：550円<span style="font-size: 0.8rem;">（税込）</span></p>
        </div>
        <h2>カードで決済</h2>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <stripe-element-card ref="stripeCardElememt" :pk="publishableKey" :hidePostalCode="true"
            @token="tokenCreated" />
        </div>
        <br>
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0;">
          <li>※Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }" target="_blank"
              style="color: #004D40; border-bottom: 1px solid #004D40;">利用規約</router-link>、<router-link
              id="footer-link-policy" :to="{ name: 'policyPage' }" target="_blank"
              style="color: #004D40; border-bottom: 1px solid #004D40;">個人情報保護方針</router-link>、<a href="/yagiprimeterms"
              target="_blank">ヤギプライム利用規約</a>をご確認ください。</li>
          <li>※フォントの利用はヤギプライム登録期間中のみになります。</li>
          <li>※ヤギプライム解除後はフォントの利用ができなくなるのでご注意ください。</li>
          <li>※ヤギプライムについての説明は<a href="/yagiprimeinfo" target="_blank">こちら</a>をご確認ください。</li>
        </ul>
      </div>
      <div style="display: inline-block; min-width: 100%; text-align: center;">
        <p style="font-size: 1rem; font-weight: bold;">
          <img src="/static/renew_img/check_icon.png" style="width: 30px;">上記規約に同意して、<br>ヤギプライムサービスを購入して利用開始
        </p>
      </div>
      <div class="text-center" style="padding: 10px;">
        <el-button id="prime-font-payment-btn" type="success" v-if="isFontpaymentSended == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="sendFontpayment">購入する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isFontpaymentSended == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeFontpaymentDialog();">購入しました</el-button>
        <br>
      </div>

      <div style="opacity: 0.8;">
        <h3 class="payment-h3">ヤギプライムに関する注意事項</h3>
        <ul style="font-size: 12px;">
          <li>
            <p style="font-weight: bold;margin-top: 10px">販売価格</p>
            <p>30日間ごとに550円(税込)となります。通信等にかかる費用は別途お客様のご負担となります。</p>
          </li>
          <li>
            <p style="font-weight: bold;margin-top: 10px;">支払い時期及びサービスの開始時期</p>
            <p>
              本サービスにお申込みいただき、お客様の登録が完了した時点でクレジットカードによりご利用代金が引き落とされると同時に、サービスが開始されます。初回のサービス提供期間終了後、自動更新され、以降30日ごとに550円（税込）がかかります。利用代金は更新されたサービス期間の毎初日に登録されたクレジットカードから引き落とされます。
            </p>
          </li>
          <li>
            <p style="font-weight: bold;margin-top: 10px;">支払方法</p>
            <p>クレジットカード（Visa・MasterCard・American Express・JCB・Diners Club・Discover）をご利用いただけます。</p>
          </li>
          <li>
            <p style="font-weight: bold;margin-top: 10px;">契約の申し込みの撤回又は解除</p>
            <p>お申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 150%;">ヤギプライムサービス購入完了</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">

          </p>
        </div>
        <p class="thanks-txt">
          ヤギプライム会員にご登録ありがとうございます！</p>
        <p style="text-align:left;" class="note-txt">ヤギプライムへのお支払いが完了しました。早速、ヤギプライムの機能を使ってみましょう！</p>
        <div class="prime-btnblock">
          <a href="/yagiprime/info" class="prime-btn">続けて希望条件を設定する</a>
        </div>
        <ul style="text-align: left; font-size: 0.7rem; margin-left: 0;">
          <li>※フォントの切り替え方法については<a href="/fontservicehelp" target="_blank">こちら</a>をご確認ください。</li>
        </ul>
      </div>
    </div>
    <div class="text-right">
      <el-button @click="closeFontpaymentDialog">閉じる</el-button>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<style lang="scss" scoped>
.prime-btnblock {
  text-align: center;
}

.prime-btn {
  display: block;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  background: #004d40;
  width: 250px;
  margin: 0 auto;
  border-radius: 50px;
  padding: 10px 0;
}
</style>
<script>

import { StripeElementCard } from '@vue-stripe/vue-stripe'

export default {
  components: {
    StripeElementCard
  },
  data: function () {
    return {
      isPaymentYagiprime: true,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isFontpaymentSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      paypayurl: '',
      merchant_payment_id: '',
      isAgree: false
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      //console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed');
      }
    })
  },
  computed: {
  },
  methods: {
    openFontpaymentDialog: function (id) {
      this.formatid = id
      this.$modal.show('yagiprimefontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.authStateChanged()

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'yagiprimefontpayment_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed');
        }
      })
    },
    tokenCreated(token, merchant_payment_id = '') {
      const app = this
      app.$eventHub.$emit('loading_on')
      this.token = ""
      if (token) {
        this.token = token.id
      }
      if (merchant_payment_id) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.status);

          if (response.status == 201) {
            app.$globalVar.isYagiPrime = true
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            const subformData = new FormData()
            subformData.append('route', 'fontservice')
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })


            app.registerComple = true
            app.permissionType = 2
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    closeFontpaymentDialog: function () {
      this.$modal.hide('yagiprimefontpayment-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    sendFontpayment: async function () {
      this.fullscreenLoading = true
      if (this.isPaymentYagiprime) {
        this.isPaymentYagiprime = false
        this.$refs.stripeCardElememt.submit()

      }
    },
    authStateChanged: async function () {
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          if (response.data.is_subscribed) {
            app.$message({
              message: 'すでにヤギプライム登録中です。',
              type: 'success'
            })
            app.$modal.hide('yagiprimefontpayment-dialog')
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-yagiprimefontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$on('open-fontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$on('popstate', this.closeFontpaymentDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-yagiprimefontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$off('open-fontpayment-dialog', this.openFontpaymentDialog)
    this.$eventHub.$off('popstate', this.closeFontpaymentDialog)
  }
}
</script>
